export const SIMULATION_CONFIG = {
  defaultSpins: 100000,
  minSpins: 1,
  maxSpins: 1000000,
  presets: [10000, 100000, 1000000],
  batchSize: 2500,
  alpha: 0.05,
  confidenceZ: 1.96,
};